import { MessageCircle, ShoppingCart } from 'lucide-react';
import { NavCountBadgeUrgent } from './sidebar/SidebarItem';

function HeaderIconButton({
  label,
  title,
  count,
  onClick,
  icon: Icon,
  testId,
}) {
  const hasBadge = Number(count) > 0;
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={hasBadge ? `${label} — ${count > 99 ? '99+' : count}` : label}
      data-testid={testId}
      className="relative inline-flex h-10 w-10 items-center justify-center rounded-xl text-gray-600 hover:bg-gray-100 hover:text-gray-900"
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
      {hasBadge ? (
        <span className="absolute -right-0.5 -top-0.5">
          <NavCountBadgeUrgent count={count} />
        </span>
      ) : null}
    </button>
  );
}

/**
 * Raccourcis header commerçant : Chat + Commandes (badges actionnables).
 * Visible uniquement en contexte commerçant (ou assistance).
 */
export default function HeaderMerchantShortcuts({
  chatCount = 0,
  ordersCount = 0,
  onOpenChat,
  onOpenOrders,
  showChat = true,
  showOrders = true,
}) {
  if (!showChat && !showOrders) return null;

  return (
    <div className="flex items-center gap-1 sm:gap-1.5" data-testid="header-merchant-shortcuts">
      {showChat ? (
        <HeaderIconButton
          label="Chat"
          title={chatCount > 0 ? `${chatCount} message(s) non lu(s)` : 'Chat clients'}
          count={chatCount}
          onClick={onOpenChat}
          icon={MessageCircle}
          testId="header-chat-shortcut"
        />
      ) : null}
      {showOrders ? (
        <HeaderIconButton
          label="Commandes"
          title={ordersCount > 0 ? `${ordersCount} commande(s) en cours` : 'Mes commandes'}
          count={ordersCount}
          onClick={onOpenOrders}
          icon={ShoppingCart}
          testId="header-orders-shortcut"
        />
      ) : null}
    </div>
  );
}
